<template>
  <div>
    <div class="ml-2 mt-12 text-h5">分類登録</div>
    <div class="ml-4 blue-grey--text">赤印のある項目は必須入力です</div>
    <alert :errors="errors" css_class="ma-1"></alert>
    <v-container style="max-width: 800px" v-show="view_status.editable">
      <v-row
        v-for="input in inputs"
        :key="input.key"
        no-gutters
        dense
        class="mb-2"
      >
        <v-col cols="4">
          <v-subheader class="title mr-2" style="height: 100%"
            >{{ input.title
            }}<v-icon class="ml-1 mb-3 red--text caption" v-if="input.required"
              >mdi-asterisk</v-icon
            ></v-subheader
          ></v-col
        >
        <v-col>
          <v-text-field
            v-if="input.key == 'category'"
            outlined
            dense
            hide-details="auto"
            :label="input.title"
            v-model.trim="$v.formData.category.$model"
            :error-messages="categoryErrorMessage"
            :error-count="3"
          ></v-text-field>
          <append-one-column-select-list
            v-if="input.key == 'restrictedGroups'"
            ref="restrictionSelect"
            :contents="permission"
            :min="0"
            :appendable="true"
          ></append-one-column-select-list>
        </v-col>
      </v-row>
    </v-container>

    <v-container style="max-width: 800px">
      <v-row justify="center" style="text-align: center">
        <v-col cols="6">
          <v-btn
            color="secondary"
            outlined
            class="ma-2"
            width="200"
            @click="cancel"
            >キャンセル</v-btn
          >
        </v-col>
        <v-col cols="6">
          <v-btn
            color="primary"
            class="ma-2"
            width="200"
            @click="register"
            :disabled="!view_status.editable"
            >登録</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Api from "@/logic/api/api.js";
import Validate from "@/logic/common/validate.js";
import Roles from "@/logic/common/roles.js";
import Alert from "../components/common/alert.vue";
import AlertBuilder from "../logic/common/alert-contents";
import { required, maxLength } from "vuelidate/lib/validators";
import valueMapper from "../logic/common/value-mapper";
/* import AppendSelectList from "../components/common/append-select-list.vue"; */
import ValueConverer from "../logic/common/value-converter";
import AppendOneColumnSelectList from "../components/common/append-one-column-select-list.vue";

export default {
  components: {
    /* "append-select-list": AppendSelectList, */
    "append-one-column-select-list": AppendOneColumnSelectList,
    alert: Alert,
  },
  validations: {
    formData: {
      category: {
        required,
        maxLength: maxLength(64),
      },
    },
  },
  computed: {
    disableRegisterButton() {
      return Validate.hasError([this.$v.formData.category]);
    },
    categoryErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.category,
        "分類",
        ["required", "maxLength"],
        !this.delayCheck
      );
    },
  },
  data() {
    // URLから参照先を取得する
    const uid = this.$route.params.uid;
    const isCreate = uid == "create" ? true : false;
    console.log("uid = " + uid);
    console.log("isCreate = " + isCreate);
    // 画面に表示する項目
    const inputs = [];
    inputs.push({
      key: "category",
      title: "分類",
      required,
    });
    inputs.push({
      key: "restrictedGroups",
      title: "閲覧制限グループ",
    });
    this.$nextTick(() => {
      this.loadData(uid);
    });
    return {
      view_status: {
        editable: false,
      },
      isCreate: isCreate,
      recordId: uid,
      permission: {
          text: "-",
          value: null,
      },
      permissionRoles: Roles.groupToGroupRoles(),
      inputs: inputs,
      delayCheck: false,
      parentGroup: {
        text: "-",
        value: "",
      },
      parentList: [],
      formData: {
        category: "",
      },
      updateData: {
        restrictedIds: [],
      },
      errors: [],
    };
  },
  methods: {
    /**
     * 分類を取得、画面に表示する
     */
    loadData(uid) {
      console.log("loadData(uid) = " + uid);
      this.view_status.editable = false;
      this.$store.commit("setWaiting", true);
      this.$nextTick(() => {
        // 分類を反映する
        console.log("displayCategoryData");
        const displayCategoryData = (category) => {
          // 分類を設定する
          console.log("category.category = " + category.category);
          this.formData.category = category.category;
        };
        const displayRestrictedGroupsData = (restrictedGroups) => {
          // グループを設定する
          this.$refs.restrictionSelect[0].setSelected(restrictedGroups);
        };
        const apiRequests = [];
        const processList = [];

        // 分類を取得する
        apiRequests.push("category.list");
        processList.push(
          Api.call("/admin/information/category", {})
        );

        // グループ情報を取得する
        apiRequests.push("group.list");
        processList.push(
          Api.call("/admin/group", {
            purpose: "GROUP_TREE_READABLE",
          })
        );

        // 必要なAPIを全て実行する
        Promise.all(processList)
          .then((result) => {
            this.$store.commit("setWaiting", false);
            if (apiRequests.includes("category.list")) {
              var categoryList = result[apiRequests.indexOf("category.list")].categorys;
              console.log("categoryList = ");
              console.log(JSON.stringify(categoryList));
              if (uid != "create") {
                var found = categoryList.find(e => e.record_id == uid);
                console.log("found = " + JSON.stringify(found));
                displayCategoryData(found);
              }
            }
            this.view_status.editable = true;
            if (apiRequests.includes("group.list")) {
              //this.permission = result[apiRequests.indexOf("group.list")].group_list;
              this.permission = ValueConverer.groupForSelectbox(
                result[apiRequests.indexOf("group.list")].group_list,
                this.$store.getters.userGroupIds
              );
              console.log("permission = " + JSON.stringify(this.permission));
              if (uid != "create") {
                var restrictedGroups = this.permission
                  .filter(group => found.restricted_groups.includes(group.value))
                  .map((group) => {
                    return {
                      name: group,
                    };
                  });
                console.log("restrictedGroups = " + JSON.stringify(restrictedGroups));
                displayRestrictedGroupsData(restrictedGroups);
              }
            }
          })
          .catch((result) => {
            // エラーになったリクエストが一つでもあればここに入る
            this.$store.commit("setWaiting", false);
            const message = valueMapper
              .map({
                403: AlertBuilder.error("権限がありません"),
              })
              .getOrElse(result.status, AlertBuilder.invalid());
            if (message.isInvalid) {
              Api.resolve(result);
            } else {
              this.showMessage(message);
            }
          });
      });
    },
    /**
     * メッセージを初期化する
     */
    clearMessage() {
      this.errors = [];
    },
    /**
     * メッセージを表示する
     */
    showMessage(error) {
      this.errors.push(error);
      window.scrollTo(0, 0);
    },
    /**
     * 登録データを作成する
     */
    sendBaseData() {
      console.log("this.formData.category = " + this.formData.category);
      console.log("characterSet = " + this.formData.category.characterSet);
      console.log("restrictionSelect = " + JSON.stringify(this.$refs.restrictionSelect[0].getAllContents()));
      return {
        category: this.formData.category,
        restricted_groups: this.$refs.restrictionSelect[0]
          .getAllContents()
          .map((item) => {
            return item.name.value;
          }),
      };
    },
    /**
     * 登録データを作成する
     */
    buildRegisterData() {
      return {
        ...this.sendBaseData(),
      };
    },
    /**
     * 更新データを作成する
     */
    buildUpdateData() {
      console.log("this.recordId = " + this.recordId);
      console.log("this.uid = " + this.uid);
      return {
        record_id: Number(this.recordId),
        ...this.sendBaseData(),
      };
    },
    /**
     * データを登録する
     */
    register() {
      this.delayCheck = true;
      this.clearMessage();
      console.log("register()");
      // リクエストパラメータを作成する
      let updateUrl = "";
      let postData = null;
      if (this.isCreate) {
        updateUrl = "/admin/information/category/create";
        postData = this.buildRegisterData();
        console.log("postData(create) = " + JSON.stringify(postData));
      } else {
        updateUrl = "/admin/information/category/update";
        console.log("postData(update) = " + JSON.stringify(postData));
        postData = this.buildUpdateData();
      }
      // APIを実行する
      this.$store.commit("setWaiting", true);
      console.log("Api.call in category-edit.vue");
      console.log("updateUrl = " + updateUrl);
      console.log("postData = " + JSON.stringify(postData));
      Api.call(updateUrl, postData)
        .then(() => {
          this.$store.commit("setWaiting", false);
          this.$router.push("/category");
        })
        .catch((error) => {
          this.$store.commit("setWaiting", false);
          console.log("error = " + error);
          console.log("error.status = " + error.status);
          if (!error.status) {
            console.log("JSONエラーは後で確認");
            this.$store.commit("setWaiting", false);
            this.$router.push("/category");
          }
          const message = valueMapper
            .map({
              401: AlertBuilder.invalid(),
              409: AlertBuilder.error("編集が競合しています"),
            })
            .getOrElse(error.status, AlertBuilder.error("更新に失敗しました"));
          if (message.isInvalid) {
            Api.resolve(error);
          } else {
            this.showMessage(message);
          }
        });
    },
    cancel() {
      this.$router.push("/category");
    },
  },
};
</script>

<style scoped>
.title {
  background-color: #999999;
  color: white;
}
</style>
